import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { createExitMttStagingToLoungeOutbound } from '../../../api/outbound/mttStagingOutbounds';
import { useSocketSend } from '../../../context/webSocket/webSocketContext';
import { ArrowTopLeftThickIcon } from '../../../icons/arrowTopLeftThickIcon';
import { MttStagingReadyButtonContainer } from '../mttStagingReadyButtonContainer';
import { MttStagingStartButtonContainer } from '../mttStagingStartButtonContainer';
import { AutoMttStagingTimerContainer } from './autoMttStagingTimerContainer';
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: 8px;
  gap: 2px 5px;
`;
export const MttStagingControlsHeaderContainer = () => {
    const socketSend = useSocketSend();
    const onClickExit = useCallback(() => {
        socketSend(createExitMttStagingToLoungeOutbound());
    }, [socketSend]);
    return (_jsxs("div", { css: CONTAINER_CSS, children: [_jsx(Button, { variant: 'contained', onClick: onClickExit, startIcon: _jsx(ArrowTopLeftThickIcon, {}), children: "Exit" }), _jsx(MttStagingReadyButtonContainer, {}), _jsx(MttStagingStartButtonContainer, {}), _jsx(AutoMttStagingTimerContainer, {})] }));
};
